<form fsForm [submit]="submit" [dirtySubmitButton]="false" [confirm]="false">

  <app-logo></app-logo>

  <h2>
    Updated {{ header }} 
    <div class="subheading">Effective {{ effectiveDate | fsDateFormat }}</div>
  </h2>

  <p *ngIf="message">{{message}}</p>
  <p>Please, review and accept the following terms in order to continue using the platform</p>

  <div class="terms">
    <fs-label>{{termsLabel}}</fs-label>
    <div class="terms-content">
      <fs-html-renderer [html]="content"></fs-html-renderer>
    </div>
  </div>

  <fs-checkbox-group
      [(ngModel)]="agreement"
      [required]="true"
      name="agreement"
      orientation="vertical">
    <mat-checkbox value="agreement">
    {{agreeLabel}}
    </mat-checkbox>
  </fs-checkbox-group>

  <app-stacked-buttons>
    <button type="submit" mat-flat-button color="primary">Continue</button>
    <button type="button" mat-stroked-button (click)="cancel()">Cancel</button>
  </app-stacked-buttons>
</form>